import Base from './Base';

const ENTITY = 'services';
export const REDUCER_NAME = 'servicesDetail';

const initialState = { isFetching: true, isSingleObject: true, values: {} };
const news = new Base(REDUCER_NAME, initialState);

export const reducer = news.reducer.bind(news);
news.getAsync.bind(news);

export const get = (id) => {
  return news.getAsync(`${ENTITY}/${id}`);
};



// WEBPACK FOOTER //
// ./src/redux/modules/service-detail.js